'use strict';

var React = require('react');

const SvgNg = ({ title, titleId, ...props }) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId }, props),
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M0 12c0 5.16 3.256 9.558 7.826 11.253V.746C3.256 2.442 0 6.84 0 12ZM24 12c0-5.16-3.257-9.558-7.826-11.254v22.507C20.744 21.558 24 17.16 24 12Z", fill: "#6DA544" })));

module.exports = SvgNg;
